import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router,
} from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable, from, of } from 'rxjs';

import { map } from 'rxjs/operators';
import { AuthService } from 'src/app/services/auth/auth.service';
import { DropdownService } from 'src/app/services/dropdown/dropdown.service';
import { LoginResponseData } from 'src/app/interfaces/LoginResponseData';

@Injectable({ providedIn: 'root' })
export class PassChangeReqGuard {
  constructor(
    private authService: AuthService,
    private router: Router,
    private dropService: DropdownService,
  ) {}

  async canActivate(
    route: ActivatedRouteSnapshot,
    router: RouterStateSnapshot,
  ): Promise<boolean | UrlTree> {
    let statusResponse: Observable<LoginResponseData> =
      await this.authService.checkStatus();
    let returnValue: Promise<boolean | UrlTree> = statusResponse
      .pipe(
        map((res: LoginResponseData) => {
          if (res.status == 2) {
            return true;
          } else {
            return false;
          }
        }),
      )
      .toPromise() as Promise<boolean | UrlTree>;

    return returnValue;
  }
}
